import { useMutation, useQueryClient } from "react-query";
import { updateDigitalInterest } from "../apis";
import { toast } from "sonner";

export const useDigitalMutation = ({refetch, query}:{refetch?:()=>void | Promise<void>, query?:string}) => {
    const queryClient = useQueryClient();
  return useMutation({
      mutationFn: updateDigitalInterest,
      onSuccess: () => {
        toast.success("Digital Interest updated successfully");
        // Optionally, you can trigger a refetch or update the state here
        // queryClient.invalidateQueries("opportunity");
        if (query) {
          // If you want to refetch a specific query
          queryClient.invalidateQueries(query)
        }
        if (refetch) {
          refetch();
        }
      },
      onError: () => {
        toast.error("Failed to update Digital Interest");
      },
    })

};
